<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <v-layout row class="small-text ma-0 mt-3">
            Текущее состояние: <span class="small-text font-weight-medium mx-1">{{textValue}}</span>
        </v-layout>
        <div class="small-text ma-0 mt-3 btn-row" v-if="deviceData.state">
            <v-btn
                class="btn-dark small-btn"
                :class="{'btn-dark-active': deviceData.state.running}"
                @click="sendDeviceValue('opening')"
                :disabled="deviceData.state.running || loading || deviceData.state.value == 100"
            >
                <div
                    v-html="require('!html-loader!@/assets/icons/curtains/arrow_right_icon.svg')"
                    class="d-inline-flex rotate-180"
                />
                <div
                    v-html="require('!html-loader!@/assets/icons/curtains/arrow_right_icon.svg')"
                    class="d-inline-flex"
                />
            </v-btn>
            <v-btn
                :loading="loading"
                class="btn-dark small-btn"
                :class="{'btn-dark-active': deviceData.state.running}"
                @click="sendDeviceValue('stop')"
                :disabled="!deviceData.state.running || loading"
            >
                <div
                    v-html="require('!html-loader!@/assets/icons/curtains/pause.svg')"
                    class="d-inline-flex"
                />
            </v-btn>
            <v-btn
                class="btn-dark small-btn"
                :class="{'btn-dark-active': deviceData.state.running}"
                @click="sendDeviceValue('closing')"
                :disabled="deviceData.state.running || loading || deviceData.state.value == 0"
            >
                <div
                    v-html="require('!html-loader!@/assets/icons/curtains/arrow_right_icon.svg')"
                    class="d-inline-flex"
                />
                <div
                    v-html="require('!html-loader!@/assets/icons/curtains/arrow_right_icon.svg')"
                    class="d-inline-flex rotate-180"
                />
            </v-btn>
        </div>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}, &nbsp
            </div>
        </v-flex>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "CurtainsDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: { state: { value: 0 } },
            deviceState: false,
            deviceStateOldValue: null,
            loading: false,
            scrollPrev: 0,
            scrollNext: 0,
            scrollTimeout: null,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state.value > 0 ? true : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
    },
    computed: {
        isScrolled() {
            return this.$store.state.scrolled;
        },
        readonly() {
            return this.scrollPrev == this.scrollNext;
        },
        textValue() {
            return this.deviceData.state ?
                this.deviceData.state.value == null ? "открыты" :
                    this.deviceData.state.value == 0 ? "закрыты" :
                        this.deviceData.state.value == 100 ? "открыты" :
                            this.deviceData.state.value > 49 ? `открыты на ${this.deviceData.state.value}%` :
                                `закрыты на ${100 - this.deviceData.state.value}%` :
                                    "не определено";
        },
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                this.deviceState = this.deviceData.state.value > 0 ? true : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        isScrolled(val) {
            this.scrollNext = val;
            this.checkScroll();
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        checkScroll() {
            if (this.scrollPrev != this.scrollNext) {
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = setTimeout(() => {
                    this.scrollPrev = this.scrollNext;
                }, 800);
            }
        },
        changeDeviceSwitch() {
            if (!this.deviceData.is_action) {
                if (this.deviceState) {
                    this.deviceData.state.value = 100;
                } else {
                    this.deviceData.state.value = 0;
                }
                this.changeDeviceValue();
            }
        },
        changeDeviceSlider() {
            if (!this.deviceData.is_action) {
                setTimeout(() => {
                    this.changeDeviceValue();
                }, 1000);
            }
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/home/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value
            })
                .catch((error) => {
                    console.log(error);
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.state = this.deviceStateOldValue;
                    this.deviceData.disabled = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        sendDeviceValue(state) {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.loading = false;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/home/device/' + this.deviceData.uid + '/state', {
                command: state,
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.loading = false;
                    console.log(error);
                });
        },
    },
}
</script>

<style lang="scss" scoped>
.btn-row {
    gap: 16px;
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.small-btn.btn-grey.v-btn {
    min-width: 64px;
    max-width: 30%;
    display: inline-flex;
}
.rotate-180.v-image {
    transform: rotate(180deg);
}
</style>